
//src/assets/scripts/top/page.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper';
import 'swiper/css';
import "swiper/css/scrollbar";
import { Autoplay, Scrollbar, Mousewheel, Navigation, FreeMode, Thumbs } from "swiper/modules";

export default class PageJS {
    constructor(common) {
        this.common = common;
    }

    init() {
        
        this._modal();
        this._secTypeSwiper();
        
        this.common.init();//common.jsはここでinitさせる

    }

    getAssetPath(relative) {
        const hostname = window.location.hostname;
        const isLocal =
            hostname === 'localhost' ||
            hostname === '127.0.0.1' ||
            hostname.endsWith('.local');
        if (isLocal) {
            return `/dist/assets/images/${relative}`;
        } else {
            return `/wp/wp-content/themes/theme-villamom/dist/assets/images/${relative}`;
        }
    }

    _modal_BK() {
        const buttons = document.querySelectorAll("[data-modal-open]");
        const modals = document.querySelectorAll("[data-modal]");
        const body = document.body;

        let activeModal = null;

        const open = (name) => {
            const target = document.querySelector(`[data-modal="${name}"]`);
            if (!target) return;

            activeModal = target;

            target.classList.add("is-open");
            body.classList.add("is-modal-open");

            this._isModalOpen = true;
        };

        const close = () => {
            if (!activeModal) return;

            activeModal.classList.remove("is-open");
            body.classList.remove("is-modal-open");

            activeModal = null;

            this._isModalOpen = false;
        };

        buttons.forEach((btn) => {
            btn.addEventListener("click", () => {
                open(btn.dataset.modalOpen);
            });
        });

        modals.forEach((modal) => {
            modal.addEventListener("click", (e) => {
                if (e.target.closest("[data-modal-close]")) {
                    close();
                }
            });
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") close();
        });

        const wrap = document.querySelector('.c-modal__wrap');
        console.log(wrap.scrollHeight, wrap.clientHeight);
    }
    _modal() {
        const buttons = document.querySelectorAll("[data-modal-open]");
        const modals = document.querySelectorAll("[data-modal]");
        const body = document.body;

        let activeModal = null;

        const setModalTab = (modal, index) => {
            if (!modal) return;

            const btns = modal.querySelectorAll(".tab_btn_area .Js_tab_btn li");
            const boxes = modal.querySelectorAll(".Js_tab_box .box");

            if (!btns.length || !boxes.length) return;
            if (index < 0 || index >= btns.length || index >= boxes.length) return;

            btns.forEach((el) => el.classList.remove("current"));
            boxes.forEach((el) => el.classList.remove("current"));

            btns[index].classList.add("current");
            boxes[index].classList.add("current");
        };

        const open = (name, tabIndex = 0) => {
            const target = document.querySelector(`[data-modal="${name}"]`);
            if (!target) return;

            activeModal = target;

            setModalTab(target, tabIndex);

            target.classList.add("is-open");
            body.classList.add("is-modal-open");

            this._isModalOpen = true;
        };

        const close = () => {
            if (!activeModal) return;

            activeModal.classList.remove("is-open");
            body.classList.remove("is-modal-open");

            activeModal = null;

            this._isModalOpen = false;
        };

        buttons.forEach((btn) => {
            btn.addEventListener("click", () => {
                const modalName = btn.dataset.modalOpen;
                const tabIndex = Number(btn.dataset.modalTab || 0);
                open(modalName, tabIndex);
            });
        });

        modals.forEach((modal) => {
            modal.addEventListener("click", (e) => {
                if (e.target.closest("[data-modal-close]")) {
                    close();
                }
            });
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") close();
        });

        const wrap = document.querySelector(".c-modal__wrap");
        if (wrap) {
            console.log(wrap.scrollHeight, wrap.clientHeight);
        }
    }


    
    _secTypeSwiper() {
        const sliderNames = [
            "type_a",
            "type_b",
            "type_c",
           "type_d",
        ];

        const createMenuSwiper = (name) => {
            const el = document.querySelector(`.${name}_swiper`);
            const el2 = document.querySelector(`.${name}_thumbnail`);
            if (!el || !el2) return;

            const sliderThumbnail = new Swiper(el2, {
                slidesPerView: "auto",
            });

            new Swiper(el, {
                modules: [Thumbs],
                slidesPerView: "auto",
                spaceBetween: 0,
                speed: 600,
                thumbs: {
                    swiper: sliderThumbnail,
                },
            });
        };

        sliderNames.forEach(createMenuSwiper);
    }

    _secTypeSwiper_bk() {
        const areas = document.querySelectorAll('[data-type-swiper]');
        if (!areas.length) return;

        areas.forEach((area) => {
            const main = area.querySelector('.type_swiper');
            const thumb = area.querySelector('.type_thumbnail');

            if (!main || !thumb) return;

            const sliderThumbnail = new Swiper(thumb, {
                slidesPerView: "auto",
            });

            new Swiper(main, {
                modules: [Thumbs],
                slidesPerView: "auto",
                spaceBetween: 0,
                speed: 600,
                thumbs: {
                    swiper: sliderThumbnail,
                },
            });
        });
    }


  
    

}







